import React, { useState, useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import "../components/Table/Table.css";
import { useTranslation } from "react-i18next";

const DeactivatedStudentReport = () => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState(false);

  const handleSearchClick = () => {
    setShowTable(true);
  };

  const handleCancleClick = () => {
    setShowTable(false);
  };

  return (
    <>
      <div className="px-2 px-md-4">
        <div className="my-4 col-12 d-flex justify-content-between align-items-center">
          <h5 className="">{t("Deactivated Student Report")}</h5>
        </div>
        <div className="row">
          <div className="col-md-4">
            <label className="form-label">
              {t("Class")}
              {<span style={{ color: "red" }}>*</span>}
            </label>
            <select name="day" className="common-input form-select" required>
              <option value="">Select Class</option>
              <option value="Nursery">Nursery</option>
              <option value="KG">KG</option>
              <option value="1st Standard">1st Standard</option>
              <option value="2nd Standard">2nd Standard</option>
            </select>
          </div>
          <div className="col-md-4">
            <label className="form-label">
              {t("Section Name")}
              {<span style={{ color: "red" }}>*</span>}
            </label>
            <select name="day" className="common-input form-select" required>
              <option value="">Select Section Name</option>
              <option value="">Nursery-A</option>
              <option value="">Nursery-B</option>
              <option value="">Nursery-C</option>
            </select>
          </div>
          {/* <div className="col-md-4">
            <label className="form-label">
              {t("Birth Date")}
              {<span style={{ color: "red" }}>*</span>}
            </label>
            <input type="date" className="form-control"></input>
          </div> */}
        </div>
        <div className="row col-6 mt-5 d-flex mx-1">
          <button
            type="submit"
            className="btn btn-primary me-2 col-md-2"
            onClick={handleSearchClick}
          >
            {t("Search")}
          </button>

          <button
            type="submit"
            className="btn btn-secondary me-2 col-md-2"
            onClick={handleCancleClick}
          >
            {t("Cancel")}
          </button>
        </div>

        {showTable && (
          <div className="Table mb-4">
            <TableContainer
              component={Paper}
              style={{ boxShadow: "0px 13px 20px 0px #80808029" }}
              className="my-4"
            >
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>{t("Sr. No.")}</TableCell>
                    <TableCell align="left">{t("Roll Number")}</TableCell>
                    <TableCell align="left">{t("Name")}</TableCell>
                    <TableCell align="left">{t("Class")}</TableCell>
                    <TableCell align="left">{t("Section")}</TableCell>
                    <TableCell align="left">{t("Reason of Deactivate")}</TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </TableContainer>
          </div>
        )}
      </div>
    </>
  );
};

export default DeactivatedStudentReport;

